// ScriptHandler.js
export default class ScriptHandler {
    constructor(cloudFunctionUrl) {
        this.cloudFunctionUrl = cloudFunctionUrl;
    }

    async generateScript(accomplishments, blockers, userToken) {
        const response = await fetch(this.cloudFunctionUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`,
            },
            body: JSON.stringify({ accomplishments, blockers }),
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.error || 'Failed to generate script');
        }

        return result.response;
    }
}
